import React from 'react';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
const ContactUs: React.FC = () => {
const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
    const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
    const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
    const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
    const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
  return (
     <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
        <main
        className="home-container"       
       style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>
    
      <div className="max-w-4xl mx-auto space-y-4 px-3">

        {/* Page Header */}
        <h1 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'}`}>
                      {"Contact Us"}
                    </h1>

        {/* Directors Block */}
        <div className={`rounded-2xl shadow-md p-6 md:p-10 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
          <h2 className="text-2xl font-semibold mb-4">Directors</h2>
          <ul className="space-y-2 text-lg">
            <li>
              <span className="font-medium">JAGDISH CHANDRA</span><br />
              <span className="text-sm">DIRECTOR</span>
            </li>
            <li>
              <span className="font-medium">ALOK KUMAR JAIN</span><br />
              <span className="text-sm">DIRECTOR</span>
            </li>
          </ul>
        </div>

        {/* Business Block */}
        <div className={`rounded-2xl shadow-md p-6 md:p-10 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
          <h2 className="text-2xl font-semibold mb-4">Business Contact</h2>
          <div className="text-lg space-y-2">
            <p>
              <strong className="">Manoj Jagyasi</strong><br />
              CBO BHARAT24Live – Vision of New India
            </p>
            <p>
              PLOT NO 17, BLOCK A, NOIDA,<br />
              Sector 62, Noida,<br />
              Gautam Buddha Nagar,<br />
              Uttar Pradesh, 201309.
            </p>
            <p>
              <strong>Tel:</strong> +91-120-6914267 & +91-120-6914268
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:contactus@bharat24live.com" className="text-blue-600 hover:underline">contactus@bharat24live.com</a>
            </p>
          </div>
        </div>

      </div>
      </main>
    </div>
  );
};

export default ContactUs;
